/**
 * VERSIONE LIBRERIA 3
 */
var Routes = {
    'list' : {
        method      : $.get,
        url         : '/api/json/{model}',
        resultType  : 'list'
    },
    'listConstraint': {
        method      : $.get,
        url         : '/api/json/{model}/{constraintKey}/{constraintValue}',
        resultType  : 'list'
    },
    'edit' : {
        method      : $.get,
        url         :'/api/json/{model}/{pk}/edit',
        resultType  : 'record'
    },
    'editConstraint' : {
        method      : $.get,
        url         :'/api/json/{model}/{pk}/edit/{constraintKey}/{constraintValue}',
        resultType  : 'record'
    },
    'search' : {
        method      : $.get, 
        url         :'/api/json/{model}/search',
        resultType  : 'record'
    },
    'insert' : {
        method      : $.get,
        url         :'/api/json/{model}/create',
        resultType  : 'record'
    },
    'insertHasmany' : {
        method      : $.get,
        url         :'/api/json/{model}/create_has_many',
        resultType  : 'record'
    },
    'insertConstraint' : {
        method      : $.get,
        url         :'/api/json/{model}/create/{constraintKey}/{constraintValue}',
        resultType  : 'record'
    },
    'saveConstraint' : { 
        method      : $.post,
        url         : '/api/json/{model}/{pk}/{constraintKey}/{constraintValue}',
        resultType  : 'record'
    },
    'save'          : { 
        method      : $.post,
        url         : '/api/json/{model}/{pk}',
        resultType  : 'record'
    },
    'create'        : { 
        method      : $.post,
        url         : '/api/json/{model}/create',
        resultType  : 'record'
    },
    'createConstraint' : { 
        method      : $.post,
        url         : '/api/json/{model}/create/{constraintKey}/{constraintValue}',
        resultType  : 'record'
    },
    'view'          : {
        method      : $.get,
        url         : '/api/json/{model}/{pk}',
        resultType  : 'record'
    },

    'remove'        : {
        method      : $.post,
        url         : '/api/json/{model}/{pk}',
        resultType  : 'record'
    },
    'removeAll'     :  {
        method      : $.post,
        url         :  '/api/json/{model}/deleteall',
        resultType  : 'record'
    },

    'set' :           {
        method      : $.post,
        url         : '/api/json/set/{model}/{field}/{value}',
        resultType  : 'record'
    },
    'calendar' :    {
        method      : $.post,
        url         : '/api/json/{model}',
        resultType  : 'list'
    },
    'csv':          {
        method      : $.get,
        url         : '/api/json/csv/{model}',
        resultType  : 'record'
    },
    'addcsv':       {
        method      : $.post,
        url         : '/queue/add/csv/load',
        resultType  : 'record'
    },
    'savecsv':       {
        method      : $.post,
        url         : '/queue/add/csv/save',
        resultType  : 'record'
    },
    'statuscsv':    {
        method      : $.get,
        url         : '/queue/status/{jobId}',
        resultType  : 'record'
    },
    'datacsv':      {
        method      : $.get,
        url         : '/api/json/csv/{model}/{jobId}',
        resultType  : 'list'
    },
    'errorcsv':      {
        method      : $.get,
        url         : '/api/json/csverror/{model}/{jobId}',
        resultType  : 'list'
    },
    'csvrevalidate':      {
        method      : $.post,
        url         : '/api/json/csv/revalidate/{model}/{jobId}',
        resultType  : 'record'
    },
    'recuperacsv':      {
        method      : $.post,
        url         : '/api/json/csvrecovery/{model}',
        resultType  : 'record'
    },
    'csvrowupdate' : {
        method      : $.post,
        url         : '/api/json/csvrowupdate/{model}',
        resultType  : 'record'
    },
    'listing' : {
        method      : $.get,
        url         : '/api/json/listing/{model}',
        resultType  : 'list'
    },
    'queueStatus' : {
        method      : $.post,
        url         : '/queue/status/{jobId}',
        resultType  : 'record'
    },
    'addQueue' : {
        method      : $.get,
        url         : '/queue/add/{queue}',
        resultType  : 'record'
    }
};

Routes.getUrlInstance = function (type,params) {
    var baseU = Routes[type];
    if (!baseU)
        throw 'invalid url type ' + type;
    var finalUrl = baseU.url;
    for (var key in params) {
        var find = '\{'+key+'\}';
        var re = new RegExp(find, 'g');
        finalUrl = finalUrl.replace(re, params[key]);
    }
    return finalUrl;
};
